import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { LogLevel, LogLevelMap } from "../../../../constant/LogLevel";
import { LogQueryParams } from "../../../../types/LayerAdmin/ImportLogsQueryParams";
import { Formik } from "formik";
import { importLogsSchema } from "./schema";
import { DateTime } from "luxon";
import { useMemo } from "react";
import styled from "styled-components";
import TimeInput from "../../../../form/time/timeInput";

interface FilterRowProps {
  params: LogQueryParams;
  onSubmit: (params: LogQueryParams) => void;
}

interface FilterLogsForm {
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  logLevel?: LogLevel;
}

const RowTitle = styled.div`
border-bottom: 1px solid lightGrey;
`;

const FilterRow = ({ params, onSubmit }: FilterRowProps) => {
  
  const initalValues = useMemo(() => ({
    startDate: params.startDate.toISO()!.split("T")[0],
    startTime: params.startDate
      .toISO()!
      .split("T")[1]
      .split("+")[0]
      .slice(0, 8),
    endDate: params.endDate.toISO()!.split("T")[0],
    endTime: params.endDate.toISO()!.split("T")[1].split("+")[0].slice(0, 8),
    logLevel: params.logLevel,
  }) as FilterLogsForm,
   [params]);



  const submit = (values: FilterLogsForm) => {
    const startDate = DateTime.fromISO(
      `${values.startDate}T${values.startTime}`
    );
    const endDate = DateTime.fromISO(`${values.endDate}T${values.endTime}`);

    onSubmit({
      ...params,
      startDate,
      endDate,
      logLevel: values.logLevel,
    });
  };


  return (
    <Formik
      validationSchema={importLogsSchema}
      enableReinitialize={true}
      onSubmit={submit}
      initialValues={initalValues}
    >
      {({ values, handleSubmit, handleChange, setFieldValue, errors }) => (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={4}>
              <RowTitle
                className="my-2 pb-1"
              >
                Logs after
              </RowTitle>
            </Col>
            <Col md={4}>
              {" "}
              <RowTitle
                className="my-2 pb-1"
              >
                Logs before
              </RowTitle>
            </Col>
            <Col md={2}>
              {" "}
              <RowTitle
                className="my-2 pb-1"
              >
                Minimum log level
              </RowTitle>
            </Col>
          </Row>{" "}
          <Row className="mb-2">
            <Col>
              <Form.Group>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={values.startDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <TimeInput 
                hasError={Boolean(errors.startTime)} 
                name="startTime" 
                value={values.startTime} 
                onChange={(e:string) => {
                  setFieldValue("startTime", e);
                }}  />
            </Col>
            <Col>
              <Form.Group>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={values.endDate}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
            <TimeInput 
                hasError={Boolean(errors.endTime)} 
                name="endTime" 
                value={values.endTime} 
                onChange={(e:string) => {
                  setFieldValue("endTime", e);
                }}  />
            </Col>
            <Col>
              {" "}
              <Form.Group>
                <Form.Control
                  as="select"
                  value={values.logLevel}
                  name="logLevel"
                  onChange={handleChange}
                >
                  <option value="">Select...</option>
                  {Array.from(LogLevelMap).map(([logLevel, label]) => (
                    <option key={logLevel} value={logLevel}>
                      {label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col className="text-center">
              <Button type="submit" className="w-75">
                Apply
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default FilterRow;
